export default {
    /**
     * Formata o preço com casas decimais
     */
    formatToPrice: price => 
        (price || 0).toLocaleString('pt-BR', { minimumFractionDigits:2, maximumFractionDigits:2 })
};